import React from 'react';
import { useAppSelector } from '../../app/hook';
import { env } from '../../config/env';
import ImageLoadingSpinner from '../loadingSpinner/imageLoadingSpinner';

const EventImageComp: React.FC<{
  imageId?: string | undefined;
  className?: string;
  divClass?: string;
  noImageClass?: string;
  noImageDivClass?: string;
  alt?: string;
  src?: string;
  loadingColor?: string;
  onImageClick?: (id: string) => void;
}> = ({
  className,
  alt,
  src,
  imageId,
  divClass,
  noImageClass,
  noImageDivClass,
  loadingColor,
  onImageClick,
}) => {
  const { isFetchingImage } = useAppSelector((state) => state.facilityProfile);
  return !imageId ? (
    <div className={noImageDivClass}>
      <img className={noImageClass} src={process.env.PUBLIC_URL + src} alt="" />
    </div>
  ) : isFetchingImage ? (
    <div className={divClass}>
      <ImageLoadingSpinner color={loadingColor} />
    </div>
  ) : (
    <div
      className={divClass}
      onClick={() => onImageClick && onImageClick(imageId)}
    >
      <img
        className={className}
        src={`${env.development.BASE_URL}/files/${imageId}`}
        alt=""
        crossOrigin=""
      />
    </div>
  );
};

export default EventImageComp;
